export const COMPARISON_MEASURE_COLUMN_NAME = 'comparisonMeasure';
export const COMPARISON_TIMESTAMP_COLUMN_NAME = 'comparisonTimestamp';
